import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Alert, AppBar, Toolbar, IconButton, Paper } from "@mui/material";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import { fetchDashboardStats, fetchAppStoreRatings } from "../../../actions/dashboardActions";
import MainContentContainer from "../../MainContentContainer/MainContentContainer";
import ContentStats from "../../Dashboard/ContentStats";
import MostPlayedWidget from "../../Dashboard/MostPlayedWidget";
import MeditationStats from "../../Dashboard/MeditationStats";
import ActiveUsersCard from "../../Dashboard/ActiveUsersCard";
import AppStoreReviews from "../../Dashboard/AppStoreReviews";
import "../../Dashboard/Dashboard.scss";

const DashboardPage = () => {
  const dispatch = useDispatch();
  // FIX: Use separate loading states to prevent race conditions
  // Previously, shared `loading` state caused the loading indicator to disappear prematurely
  // when one of two concurrent requests finished
  const { stats, appStore, loadingStats, loadingAppStore, error } = useSelector(state => state.dashboard);

  useEffect(() => {
    // Fetch dashboard data on mount
    dispatch(fetchDashboardStats());
    dispatch(fetchAppStoreRatings());
  }, [dispatch]);

  const handleRefresh = () => {
    dispatch(fetchDashboardStats());
    dispatch(fetchAppStoreRatings());
  };

  // Combine loading states for refresh button - disable if either is loading
  const isLoading = loadingStats || loadingAppStore;

  return (
    <MainContentContainer>
      <AppBar position="sticky">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Dashboard
          </Typography>
          <IconButton color="inherit" onClick={handleRefresh} disabled={isLoading}>
            <RefreshIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {error && (
        <Alert severity="error" sx={{ mt: 3, mb: 3 }}>
          {error}
        </Alert>
      )}
      <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
        {/* Top Row: Active Users, Most Played, and Meditation Stats */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
            gap: 3,
            mb: 3,
          }}
        >
          <MeditationStats completedMeditations={stats?.completed_meditations} loading={loadingStats} />
          <MostPlayedWidget mostPlayed={stats?.most_played} loading={loadingStats} />
          <ActiveUsersCard activeUsers={stats?.active_users} loading={loadingStats} />
        </Box>

        {/* Content Statistics */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" className="section-title">
            Available Content
          </Typography>
          <ContentStats stats={stats?.content_statistics} loading={loadingStats} />
        </Box>

        {/* App Store Ratings & Reviews Combined */}
        <Box sx={{ mb: 3 }}>
          <AppStoreReviews ratings={appStore} loading={loadingAppStore} />
        </Box>
      </Paper>
    </MainContentContainer>
  );
};

export default DashboardPage;
